function updateCartDrawerEmptyState() {
  const cartItems = document.querySelector('cart-drawer-items');
  const cartDrawer = document.querySelector('.drawer');

  if (!cartItems || !cartDrawer) return;

  if (cartItems.classList.contains('is-empty')) {
    cartDrawer.classList.add('is-empty');
  } else {
    cartDrawer.classList.remove('is-empty');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  updateCartDrawerEmptyState();
  document.addEventListener('rk_cart_event', updateCartDrawerEmptyState);
});

document.addEventListener('rk_cart_event', function () {
  const cart_drawer = document.querySelector('cart-drawer');
  if (cart_drawer && typeof cart_drawer.refresh === 'function') {
    cart_drawer.refresh();
  }

  setTimeout(updateCartDrawerEmptyState, 1000);
});




const swiper = new Swiper('.product-grid-slider', {
  loop: true,
  slidesPerView: 4,
  spaceBetween: 20,
  breakpoints: {
    0: {
      slidesPerView: 1.2,
      spaceBetween: 15
    },
    500: {
      slidesPerView: 2, 
      spaceBetween: 15
    },
    990: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 20
    }
  }
});


const RecipeSlider = new Swiper('.recipe-list-slider', {
  loop: false,
  slidesPerView: 4,
  spaceBetween: 20,
  pagination: {
    el: '.recipelist-section .swiper-pagination',
    clickable: true
  },
  breakpoints: {
    0: {
      slidesPerView: 1.2,
      spaceBetween: 10
    },
    500: {
      slidesPerView: 2,
      spaceBetween: 10
    },
    990: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 20
    }
  }
});


const BlogSlider = new Swiper('.blog-card-slider', {
  loop: false,
  slidesPerView: 4,
  spaceBetween: 20,
  pagination: {
    el: '.featured-blog-section .swiper-pagination',
    clickable: true
  },
  breakpoints: {
    0: {
      slidesPerView: 1.2,
      spaceBetween: 10
    },
    500: {
      slidesPerView: 2,
      spaceBetween: 10
    },
    990: {
      slidesPerView: 3,
      spaceBetween: 30
    }
  }
});


const Logoswiper = new Swiper('.logolist-slider', {
  loop: false,
  autoplay: {
    delay: 5000,
  },
  slidesPerView: 4,
  spaceBetween: 20,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    snapOnRelease: true
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      spaceBetween: 15
    },
    990: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 5,
      spaceBetween: 20
    }
  }
});

// product review section
const reviewswiper = new Swiper('.review-slider', {
  loop: false,
  autoplay: {
    delay: 5000,
  },
  navigation: {
    nextEl: ".pdp-review-section .swiper-button-next",
    prevEl: ".pdp-review-section .swiper-button-prev",
  },
  slidesPerView: 3,
  spaceBetween: 20,
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 15
    },
    769: {
      slidesPerView: 2,
      spaceBetween: 15
    },
    990: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 20
    }
  }
});


const Colswiper = new Swiper('.col-mobile-slider', {
  loop: false,
  slidesPerView: 3,
  spaceBetween: 10
});


const MediaSlider = new Swiper('.media-section-slider', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 10
});



const sliderThumbnail = new Swiper('.media-gallery-thumbnail', {
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 20,
  mousewheel: true,
  breakpoints: {
    0: {
      slidesPerView: 4,
      spaceBetween: 10
    },
    700: {
      slidesPerView: 4,
      spaceBetween: 20
    },
    1200: {
      direction: 'vertical',
    }
  }
});

const PDPMainSlider = new Swiper('.media-gallery-main', {
  loop: false,
  slidesPerView: 1,
  spaceBetween: 20,
  thumbs: {
    swiper: sliderThumbnail
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const headings = document.querySelectorAll(
    ".footer-block--menu h2.footer-block__heading"
  );

  headings.forEach((heading) => {
    heading.addEventListener("click", function () {
      headings.forEach((item) => item.classList.remove("active"));
      this.classList.add("active");
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const closeIcon = document.querySelector(".menu-drawer-close-icon");
  const menuIcon = document.querySelector(".header__icon--menu");

  if (!closeIcon || !menuIcon) return;

  closeIcon.addEventListener("click", function () {
    menuIcon.click();
  });
});

